var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLargetileDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3813_7384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 2.66634C1.33325 1.92996 1.93021 1.33301 2.66659 1.33301H5.33325C6.06963 1.33301 6.66659 1.92996 6.66659 2.66634V5.33301C6.66659 6.06939 6.06963 6.66634 5.33325 6.66634H2.66659C1.93021 6.66634 1.33325 6.06939 1.33325 5.33301V2.66634Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 2.66634C9.33325 1.92996 9.93021 1.33301 10.6666 1.33301H13.3333C14.0696 1.33301 14.6666 1.92996 14.6666 2.66634V5.33301C14.6666 6.06939 14.0696 6.66634 13.3333 6.66634H10.6666C9.93021 6.66634 9.33325 6.06939 9.33325 5.33301V2.66634Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 10.6663C1.33325 9.92996 1.93021 9.33301 2.66659 9.33301H5.33325C6.06963 9.33301 6.66659 9.92996 6.66659 10.6663V13.333C6.66659 14.0694 6.06963 14.6663 5.33325 14.6663H2.66659C1.93021 14.6663 1.33325 14.0694 1.33325 13.333V10.6663Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 10.6663C9.33325 9.92996 9.93021 9.33301 10.6666 9.33301H13.3333C14.0696 9.33301 14.6666 9.92996 14.6666 10.6663V13.333C14.6666 14.0694 14.0696 14.6663 13.3333 14.6663H10.6666C9.93021 14.6663 9.33325 14.0694 9.33325 13.333V10.6663Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3813_7384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargetileDark);
export default __webpack_public_path__ + "static/media/icon_largetile_dark.aaf747adf63b5c38258219dd531cb411.svg";
export { ForwardRef as ReactComponent };